import React from 'react';
import book from '../../content/book.json';

const Book = () => {
  return (
    <section name="book" id="book" className="bg-green-light scroll-to spacer block no-padding including-image p-top-xl">
      <div className="text-wrapper text-center">
        <div className="title">
          <h2>{book.title}</h2>
        </div>

        <div className="button-wrapper">
          <a href={book.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">{book.buttonLabel}</a>
        </div>

        <div className="content opening-hours">
          <h4>{book.hoursTitle}</h4>
          {book.hours.map((h, i) => (
            <p key={i}><strong>{h.day}</strong> - {h.time}</p>
          ))}
        </div>
      </div>

      <div className="block img img-gray" style={ { backgroundImage: `url(${book.image})` } }>
      </div>

    </section>
  );
};

export default Book;
